export default __webpack_public_path__ + "static/media/66.0ddbbba0.jpg";